import React from 'react';
import TermsPageBox from './TermsPageBox';
import PageBradcrume from '../PageBradcrume';
import {AllPagesDatas} from "../FetchAPI";
import PageMetaData from '../PageMetaData';

export default function RefundPolicy() {
  const [AllpageData] = AllPagesDatas(11);
  return (
    <>
   <PageMetaData PageId="11"/>
    <PageBradcrume Pagename={AllpageData.title} pagetitle="cancellation-refund-policy" />
    <TermsPageBox heading={AllpageData.title} desc={AllpageData.description1}/>
    </>
  )
}
